/**
 * Components Index
 *
 * Dynamically import web components only when relevant markup is present.
 */

if (document.querySelector('color-swatch-picker, color-swatch-option, [data-color-swatch-picker], [data-color-swatch-link]')) {
  import('./color-swatch-switcher.js');
}

import('./product-card-color-switcher.js');

// Quick View — shared modal that reuses the theme's quick-buy-modal
import('./quick-view.js');

if (document.querySelector('size-guide')) {
  import('./size-guide.js');
}
